import { Identifiable } from './identifiable';

export interface AuthRequestData {
  access_token: string;
  refresh_token: string;
}

export interface User extends Identifiable {
  username: string;
  email: string;
  role: string;
  active: boolean;
  user_permissions: string[];
}

export interface ChangePasswordRequest {
  userId: string;
  old_password: string;
  password: string;
  password2: string;
}

export interface LoginBasicRequest {
  email: string;
  username: string;
  password: string;
}

export interface RefreshTokenRequest {
  refresh: string;
}

export interface LogoutRequest {
  token: string;
}

export interface LogoutResponse {
  token: boolean;
}

export interface Permission {
  id: string;
  name: string;
  codename: string;
}

export const MODELS_ES: { [key: string]: string } = {};

export const PermsES: { [key: string]: string } = {
  add: 'Adicionar',
  change: 'Modificar',
  delete: 'Eliminar',
  list: 'Listar',
  view: 'Detalle',
  duplicate: 'Duplicar',
  passwordchange: 'Cambiar contraseña',
  export: 'Exportar',
  send: 'Enviar',
  cancel: 'Cancelar',
  archive: 'Archivar',
  elaborate: 'Elaborar',
  finish: 'Finalizar',
  paralyze: 'Paralizar',
};

export interface TokenDecoded {
  token_type: string;
  exp: number;
  iat: number;
  jti: string;
  user_id: number;
  id: number;
  email: string;
  username: string;
  is_active: boolean;
  user_permissions: string[];
}
